import { Box, Button, Typography, Container } from '@mui/material'
import React, { useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import CustomAppBar from '../components/CustomAppBar';
import Navbar from '../components/Navbar';
import PrimaryButton from '../components/PrimaryButton';
import AppContainer from '../components/AppContainer';
import TextContainer from '../components/TextContainer';
import SectionBanner from '../components/SectionBanner';
import DeleteIcon from '@mui/icons-material/Delete';
import { useSelector, useDispatch } from 'react-redux';
import { removeHeart, removeHeartFromReduxAndServer, updateHeartOnReduxAndServer } from '../redux/heartSlice';
import { updateGroupOnReduxAndServer } from '../redux/groupSlice';
import { addUserToReduxAndServer } from '../redux/userSlice';
import ConfirmPopup from '../components/ConfirmPopup';
import { EMPTY_GROUP_ID, LOCATION_UPDATER_TOPIC, MQTT_TOPIC_PREFIX } from '../constants';
import SettingsIcon from '@mui/icons-material/Settings';
import SectionBanner2 from '../components/SectionBanner2';
import { PRIMARY_BUTTON_BLUE } from '../colorPalette';
// formik
import { Formik, Form } from 'formik';
import EditNamePopupFormik from '../components/EditNamePopupFormik';
import { heartNameSchema } from '../validation/schemas';
import { publishMessage } from '../api/mqtt';

// Snackbar
import { useSnackbar } from 'notistack';
import { GroupSchema, HeartSchema, UserSchema } from 'lumas-shared-schemas';

function ManageHeart() {
    const navigate = useNavigate();
    const params = useParams();
    const dispatch = useDispatch();  
    const {enqueueSnackbar} = useSnackbar();

    // Get the heart from the store
    const hearts = useSelector((state) => state.heart.hearts);
    // Find the heart with the id that matches the heartId in the URL
    const user = useSelector((state) => state.user.user);
    const heart = hearts.find((heart) => heart.id === params?.heartId);
    const [namePopupOpen, setNamePopupOpen] = React.useState(false);
    const [tempName, setTempName] = React.useState(heart.name);

    // get the group that the heart belongs to, if any
    const group = useSelector((state) => state.group.groups.find((group) => group.id === heart.group));

    // delete confirmation popup
    const [deletePopupOpen, setDeletePopupOpen] = React.useState(false);

    const handleNameSave = () => {
        // Update the name of the heart, validating against schema
        const updatedHeart = HeartSchema.parse({
            ...heart, 
            name: tempName
        });
        dispatch(updateHeartOnReduxAndServer({id: heart.id, updatedHeart: updatedHeart}))
        setNamePopupOpen(false); // Close the popup when clicked outside or on a close button
    };

    const handleCancel = () => {
        setLeaveGroupPopup(false);
        setDeletePopupOpen(false); // Close the popup when clicked outside or on a close button
        setNamePopupOpen(false); // Close the popup when clicked outside or on a close button
    };

    const handleDeleteConfirm = () => {

        try{
            // remove heart from the group it is part of, if any
            if(group) {
                console.log("old group", group)
                // Validate group object against schema
                const updatedGroup = GroupSchema.parse({
                    ...group, 
                    hearts: group.hearts.filter((heartID) => heartID !== heart.id)
                });
                console.log("group found, updated group: ", updatedGroup);
                dispatch(updateGroupOnReduxAndServer({id: group.id, updatedGroup: updatedGroup}));

                // Send "DATABASE_UPDATE" to LumasHearts/groups/[groupID]/dbUpdate
                const topic = MQTT_TOPIC_PREFIX + group.id + "/dbUpdate"
                publishMessage(topic, "DATABASE_UPDATE", false)
            }
    
            // Remove the heart data - updated to reset all attributes to None and keep id
            dispatch(removeHeartFromReduxAndServer(heart.id));

            // update the User object to remove the heart from the user's hearts array, validating against schema
            const updatedUser = UserSchema.parse({
                ...user, 
                hearts: user.hearts.filter((heartID) => heartID !== heart.id)
            });
            dispatch(addUserToReduxAndServer(updatedUser));
    
            // // run the location updater script 
            // publishMessage(LOCATION_UPDATER_TOPIC, "start");
    
            navigate('/home');

        } catch (error) {
            console.log("Error deleting heart: ", error)
            enqueueSnackbar(`Error when deleting the heart. Please try again later.`, {variant: 'error'})
        }

    }


    // leave group confirmation popup
    const [leaveGroupPopup, setLeaveGroupPopup] = useState(false);

    const handleLeaveGroupConfirm = () => {
        // Create new object and validate the schemas BEFORE dispatching - will throw error if invalid

        // remove heart from the group it's part of 
        const updatedGroup = GroupSchema.parse({
            ...group, 
            hearts: group.hearts.filter((heartID) => heartID !== heart.id)
        });
        
        // set the Heart's group to default empty group ID (group: "None")
        const updatedHeart = HeartSchema.parse({
            ...heart, 
            group: EMPTY_GROUP_ID
        });

        dispatch(updateGroupOnReduxAndServer({id: group.id, updatedGroup: updatedGroup}));
        dispatch(updateHeartOnReduxAndServer({id: heart.id, updatedHeart: updatedHeart}));

        // Send "DATABASE_UPDATE" to LumasHearts/groups/[groupID]/dbUpdate
        const topic = MQTT_TOPIC_PREFIX + group.id + "/dbUpdate"
        publishMessage(topic, "DATABASE_UPDATE", false)
    
        setLeaveGroupPopup(false);
    }

    const handleFormSubmit = (values, {setSubmitting}) => {
        console.log("Values", values);
        setSubmitting(false); 

        // Update the name of the heart in the DB
        const updatedHeart = HeartSchema.parse({
            ...heart, 
            name: values.name
        });
        dispatch(updateHeartOnReduxAndServer({id: heart.id, updatedHeart: updatedHeart}))
        setNamePopupOpen(false); // Close the popup when clicked outside or on a close button
    }

    return (
        <AppContainer>
            {deletePopupOpen && (
                <ConfirmPopup title={"Are you sure you want to delete this heart?"} confirmText={"Delete"} handleCancel={handleCancel} handleConfirm={handleDeleteConfirm} />
                // <ColorPickerPopup color={color} setColor={setColor} handleSave={handleSave} handleCancel={handleCancel} />
            )}
            {namePopupOpen && (
                <Formik
                    initialValues={{ name: heart.name}}
                    validationSchema={heartNameSchema}
                    onSubmit={handleFormSubmit}
                >
                    {({ isSubmitting, errors, touched }) => (
                        <Form>
                            <EditNamePopupFormik errors={errors} touched={touched} title={"Edit Heart Name:"} handleCancel={handleCancel} />
                        </Form>
                    )}
                </Formik>
            )}
            {leaveGroupPopup && (
                <ConfirmPopup title={"Are you sure you want to remove the heart from its group?"} confirmText={"Remove"} handleCancel={handleCancel} handleConfirm={handleLeaveGroupConfirm} />
            )}
            <CustomAppBar />
            <Navbar title={"Heart Settings"} rightButtonIcon={<DeleteIcon sx={{color: 'red'}} />} backButton rightButtonOnClick={() => {setDeletePopupOpen(true)}}/>
            <TextContainer>
                <Typography variant='h5'>{heart.name}</Typography>
                <Button onClick={( ) => {setNamePopupOpen(true)}} variant='text' color='primary' sx={{textAlign: 'left', padding: 0}}>Edit Name</Button>
            </TextContainer>

            <SectionBanner2 text={"Heart Settings"} IconComponent={SettingsIcon} />
            <TextContainer>
                <Box sx={{display: "flex", flexDirection: 'row'}}>
                    <Typography variant='body2' sx={{flexGrow: 1, alignContent: 'center'}}>Group: {group === undefined ? "None" : group.name}</Typography>
                    {/* If heart's group is the empty group ID (ex: "None"), display "add heart to group", otherwise "leave group" button */}
                    {heart.group !== EMPTY_GROUP_ID 
                        ? <Button onClick={() => setLeaveGroupPopup(true)} sx={{textAlign: 'left', fontSize: '12px'}} variant='contained'>Remove</Button> 
                        : <Button onClick={() => {navigate(`/manage-heart/${params?.heartId}/add-to-group`)}} sx={{textAlign: 'left', fontSize: '12px'}} variant='contained'>Add To Group</Button> 
                    }
                </Box>
                <Box marginTop={'10px'}>
                    <Typography variant='body2' sx={{flexGrow: 1, alignContent: 'center'}}>MAC: {heart.id}</Typography>
                </Box>
            </TextContainer>
        </AppContainer>
    )
}

export default ManageHeart